<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom bg-white rounded-lg pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                            <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                </div>
                <div class="mt-2">
                    <h3 class="text-lg leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                        Agreement
                    </h3>
                    <div class="flex justify-end px-4 mb-1">
                        <a :href="`${$parent.consumerPortalBaseUrl}/agreement`" target="_blank">
                            <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                            </svg>
                        </a>
                    </div>
                    <div class="mb-4 border-t border-b border-gray-200 bg-gray-50 text-left">
                        <p class="text-sm text-gray-500 p-4" style="max-height: 24rem; overflow-y: scroll;" v-html="agreement" />
                    </div>
                    <div class="flex px-4 items-center">
                        <input @click="checked = ! checked" id="remember_me" name="remember_me" type="checkbox" :class="`mb-1 h-4 w-4 text-${$root.theme}-600 focus:ring-${$root.theme}-500 border-gray-300 rounded`">
                        <label class="ml-3 cursor-pointer" for="remember_me" id="annual-billing-label text-left">
                            <span class="text-sm font-medium text-gray-900">Click here to indicate you have read and agreed to the above disclosures.</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="mt-5 px-4 sm:mt-6">
                <button @click="agree" type="button" :class="`w-full inline-flex text-black justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`">
                    Agree
                </button>
                <div v-if="error" class="text-red-500 pt-2 text-sm text-center">
                    You must agree before moving on.
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Mixins from '../../mixins';

    export default {
        mixins: [Mixins],

        props: ['show', 'agreement'],

        watch: {
            show: {
                immediate: true,
                handler: function (show, oldShow) {
                    if (show) this.gtagEvent('agreement-loaded');
                }
            }
        },

        data() {
            return {
                checked: false,
                error: false
            }
        },

        methods: {
            /**
             * @return {void}
             */
            agree() {
                if (this.checked) {
                    this.error = false;
                    this.gtagEvent('agreement:agreed');
                    this.$emit('agree');
                } else {
                    this.error = true;
                }
            },

            /**
             * @return {void}
             */
            disagree() {
                this.gtagEvent('agreement:disagreed');

                this.$emit('close');
            }
        }
    }
</script>